import { AssignedVisitRequestStatus, VisitRequestStatus } from 'Application/Visits/Actions/enums'
import { TFunction, useTranslation } from 'react-i18next'

type Props = {
  assignedVisitRequestStatus: number
  status: number
}

function getHelperText({
  assignedVisitRequestStatus,
  status,
  t,
}: Props & { t: TFunction<'translation', undefined> }) {
  if (assignedVisitRequestStatus === AssignedVisitRequestStatus.CancelledByExpert)
    return t('VISIT_REQUEST_CANCELLED_BY_YOU')

  if (assignedVisitRequestStatus === AssignedVisitRequestStatus.Rejected)
    return t('VISIT_REQUEST_REJECTED_BY_YOU')

  if (assignedVisitRequestStatus === AssignedVisitRequestStatus.CancelledByUser)
    return t('VISIT_REQUEST_CANCELLED_BY_USER')

  if (
    status === VisitRequestStatus.Assigned &&
    assignedVisitRequestStatus === AssignedVisitRequestStatus.Registered
  )
    return t('VISIT_REQUEST_ASSIGNED_TO_ANOTHER_EXPERT')

  if (status === VisitRequestStatus.CancelledByUser) return t('VISIT_REQUEST_CANCELLED_BY_USER')

  if (status === VisitRequestStatus.Done) return t('VISIT_REQUEST_COMPLETED')

  return ''
}

export default function StatusHelperText(props: Props) {
  const { t } = useTranslation()
  return <div className="flex justify-center mb-4 text-xs">{getHelperText({ ...props, t })}</div>
}
